export default {
  apiKey: 'AIzaSyAb-78uKRAcrUn75WCSbumI8btVCEnaSoU',
  authDomain: 'beyla-1.firebaseapp.com',
  databaseURL: 'https://beyla-1.firebaseio.com',
  projectId: 'beyla-1',
  storageBucket: 'beyla-1.appspot.com',
  messagingSenderId: '1091719587345',
  appId: '1:1091719587345:web:248130fc662a8f15'
}
